var e={emptyPlaceholder:"EmptyPlaceholder__emptyPlaceholder-quU"};export{e as default};
